'use strict'

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import HelpLink from '../HelpLink/HelpLink'

class CategoryMenuPanel extends PureComponent {
  render () {
    const ccn = 'category-panel'
    const { id, title, icon, subTitles, links } = this.props
    const activeClassName = classnames([ccn], { [ccn + '__active']: id === this.props.activeCategory })

    if (!id) return null

    return (
      <div data-test={ccn + '-' + id} className={activeClassName} key={id}>
        <div className={ccn + '__header'}>
          <h2 className={ccn + '__title ' + ccn + '__title--' + id}>
            <span className={ccn + '__icon argos-icon ' + icon} />
            {title}
          </h2>
          <button className={ccn + '__button ' + ccn + '__button--' + id} onClick={(e) => this.props.toggleAccordion(e, id)} aria-hidden='true' />
        </div>
        <div className={ccn + '__menu'}>
          <span className={ccn + '__menu__title'}>{title}</span>
          <ul className={ccn + '__menu__list'}>
            {links.map((link, index) => {
              let linkNum = (index + 1)
              if (link.target) {
                return (
                  <li key={index}>
                    <HelpLink className={ccn + '__link '} href={link.link} target={link.target} data-test={ccn + '__link--' + id + '-' + linkNum}>
                      {link.name}
                      <span className={ccn + '__link--icon'} aria-hidden='true' />
                    </HelpLink>
                  </li>
                )
              }
              return (
                <li key={index}>
                  <HelpLink className={ccn + '__link '} href={link.link} data-test={ccn + '__link--' + id + '-' + linkNum}>
                    {link.name}
                    <span className={ccn + '__link--icon'} aria-hidden='true' />
                  </HelpLink>
                </li>
              )
            })}
          </ul>
        </div>
        <ul className={ccn + '__sub-titles hidden-xs'}>
          {subTitles.map((sub, index) => {
            return <li className={ccn + '__sub-titles__li'} key={index}>{sub.subTitle}</li>
          })}
        </ul>
      </div>
    )
  }
}

CategoryMenuPanel.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.string,
  subTitles: PropTypes.array,
  links: PropTypes.array,
  activeCategory: PropTypes.string,
  toggleAccordion: PropTypes.func
}

export default CategoryMenuPanel
